import { BILLING } from './types'

const initialState = {
  isBillingActive: false,
  billingLoaded: false,
  services: {
    enhanced_visibility: null,
    personal_status: null,
    early_access: null,
    activity_tracking: null,
  },
  event_requires_confirmation: false,
  permissions: [],
  referralData: {},
  shouldClosePaymentForm: false,
}

const billingReducer = (state = initialState, action) => {
  switch (action.type) {
    case BILLING.SET_IS_ACTIVE:
      return {
        ...state,
        isBillingActive: action.payload,
        billingLoaded: true,
      }

    case BILLING.SET_SERVICE_DATA: {
      const { service, data } = action.payload

      return {
        ...state,
        services: {
          ...state.services,
          [service]: data,
        },
      }
    }

    case BILLING.SET_BILLING_PERMISSIONS:
      return {
        ...state,
        ...action.payload,
      }

    case BILLING.SET_BILLING_PERMISSIONS_CURRENT:
      return {
        ...state,
        permissions: action.payload.permissions,
        isBillingActive: action.payload.status,
        billingLoaded: true,
      }
    case BILLING.SET_BILLING_EVENT:
      return {
        ...state,
        event_requires_confirmation: action.payload,
      }

    case BILLING.SET_REFERRAL_DATA:
      return {
        ...state,
        referralData: action.payload,
      }
    case BILLING.SET_SHOULD_CLOSE_PAYMENT_FORM:
      return {
        ...state,
        shouldClosePaymentForm: action.payload,
      }
    default:
      return state
  }
}

export default billingReducer
